<div class="box work-shift-shell">
  <div class="header work-shift-header">
    <div class="content greendAnalityco work-shift-title">
      <mat-icon>schedule</mat-icon>
      <span>CONFIGURACION DE HORARIO DE TRABAJO POR PROYECTO</span>
      <button type="button" class="wst-header-close" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="content-card list-card work-shift-card" autocomplete="off">
    <div class="wst-tabs" *ngIf="!loading">
      <button type="button" class="wst-tab" [class.wst-tab--active]="activeTab === 'turnos'" (click)="selectTab('turnos')">
        <mat-icon>schedule</mat-icon> Turnos
      </button>
      <button type="button" class="wst-tab" [class.wst-tab--active]="activeTab === 'patrones'" (click)="selectTab('patrones')">
        <mat-icon>view_module</mat-icon> Patrones Semanales
      </button>
      <button type="button" class="wst-tab" [class.wst-tab--active]="activeTab === 'catorcenales'" (click)="selectTab('catorcenales')">
        <mat-icon>view_module</mat-icon> Patrones Catorcenales
      </button>
    </div>

    <div class="body-scroll work-shift-body">
      <div class="wst-loading" *ngIf="loading">Cargando...</div>

      <!-- ===== Pantalla: Turnos ===== -->
      <section class="wst-screen" *ngIf="!loading && activeTab === 'turnos'">
        <div class="wst-screen-title-row">
          <div class="wst-screen-title">Configuración de turnos</div>
          <div class="wst-create-item-group" *ngIf="!turnoFormExpanded">
            <span class="wst-create-item-label">Crear nuevo turno</span>
            <span [matTooltip]="!exitPermission('projectworkshift.CreateShifts') ? 'No cuentas con el permiso para crear turnos' : ''"
                  matTooltipPosition="above"
                  style="display: inline-block">
              <button type="button" class="wst-create-item-fab" [disabled]="!exitPermission('projectworkshift.CreateShifts')" (click)="openTurnoForm()">
                <mat-icon>add</mat-icon>
              </button>
            </span>
          </div>
        </div>

        <div class="wst-form-card" [class.wst-form-card--editing]="editingTurnoLocalId" *ngIf="turnoFormExpanded">
          <div class="wst-form-header-row">
            <div class="wst-form-header">{{ editingTurnoLocalId ? 'Editar turno' : 'Crear nuevo turno' }}</div>
            <div class="wst-active-toggle" [formGroup]="turnoForm">
              <span>{{ turnoForm.get('isActive').value ? 'Activo' : 'Inactivo' }}</span>
              <mat-slide-toggle formControlName="isActive"></mat-slide-toggle>
            </div>
          </div>

          <form [formGroup]="turnoForm">
            <div class="wst-editor-name-row">
              <div class="wst-editor-field wst-editor-field--grow">
                <label>Nombre del turno</label>
                <div class="name-input-wrapper">
                  <input type="text" formControlName="name" placeholder="Ej: Mañana"
                         [class.input-error]="turnoForm.get('name').invalid && turnoForm.get('name').touched"/>
                </div>
              </div>
            </div>

            <div class="wst-editor-time-row">
              <div class="wst-editor-field">
                <label>Hora inicio</label>
                <div class="time-input-wrapper">
                  <input type="time" class="time-input" formControlName="startHour"/>
                </div>
              </div>
              <div class="wst-editor-field">
                <label>Hora final</label>
                <div class="time-input-wrapper">
                  <input type="time" class="time-input" formControlName="endHour"/>
                </div>
              </div>
            </div>

            <div class="wst-subcard">
              <div class="wst-subcard-title"><mat-icon>free_breakfast</mat-icon> Descanso</div>

              <div class="wst-editor-time-row">
                <div class="wst-editor-field">
                  <label>Descanso <em class="wst-field-format">(hh:mm)</em></label>
                  <div class="manual-time-wrapper">
                    <input type="text" inputmode="numeric" maxlength="2" placeholder="00"
                           formControlName="breakL" (focus)="selectOnFocus($event)" (blur)="padTurnoField('breakL')"
                           (input)="autoAdvance($event, breakRInput)"/>
                    <span>:</span>
                    <input #breakRInput type="text" inputmode="numeric" maxlength="2" placeholder="00"
                           formControlName="breakR" (focus)="selectOnFocus($event)" (blur)="padTurnoField('breakR')"/>
                  </div>
                </div>
                <div class="wst-editor-field">
                  <label>Trd <em class="wst-field-format">(hh:mm)</em></label>
                  <div class="manual-time-wrapper">
                    <input type="text" inputmode="numeric" maxlength="2" placeholder="00"
                           formControlName="trdL" (focus)="selectOnFocus($event)" (blur)="padTurnoField('trdL')"
                           (input)="autoAdvance($event, trdRInput)"/>
                    <span>:</span>
                    <input #trdRInput type="text" inputmode="numeric" maxlength="2" placeholder="00"
                           formControlName="trdR" (focus)="selectOnFocus($event)" (blur)="padTurnoField('trdR')"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="wst-summary-card">
              <div class="wst-summary-title">Resumen de jornada</div>
              <div class="wst-summary-stats">
                <div class="wst-summary-stat">
                  <span>Duración turno</span>
                  <strong>{{ turnoTotalTime }}</strong>
                </div>
                <div class="wst-summary-stat">
                  <span>Total descansos</span>
                  <strong>{{ turnoBreakSummary }}</strong>
                </div>
                <div class="wst-summary-stat wst-summary-stat--highlight">
                  <span>Horas efectivas</span>
                  <strong>{{ turnoWorkHours }}</strong>
                </div>
              </div>
            </div>

            <div class="name-required-alert" *ngIf="turnoHoursInvalid">
              <mat-icon style="color: red;">warning</mat-icon>
              <span>Debe indicar hora de inicio y hora final.</span>
            </div>

            <div class="wst-form-actions">
              <button type="button" class="wst-cancel-btn" (click)="cancelTurnoForm()">Cancelar</button>
              <button type="button" class="wst-save-turno-btn" [disabled]="savingTurno" (click)="saveTurno()">
                {{ savingTurno ? 'Guardando…' : (editingTurnoLocalId ? 'Guardar turno' : 'Confirmar y crear turno') }}
              </button>
            </div>
          </form>
        </div>

        <ng-container *ngIf="!turnoFormExpanded">
          <div class="wst-col-header wst-col-header--sub">
            <span>Turnos disponibles</span>
            <div class="tTrd">
              <mat-icon>info</mat-icon>
              <span><b>Trd =</b> Tiempo trabajado a partir del cual se descuenta el tiempo de descanso</span>
            </div>
          </div>
          <div class="wst-turno-list" *ngIf="turnos.length > 0">
            <div class="wst-turno-card"
                 *ngFor="let turno of turnos; trackBy: trackByTurnoId"
                 [style.background]="turno.color"
                 [class.wst-turno-card--inactive]="!isTurnoEffectivelyActive(turno)">
              <div class="wst-turno-actions">
                <span [matTooltip]="!exitPermission('projectworkshift.UpdateShifts') ? 'No cuentas con el permiso para editar turnos' : 'Editar turno'"
                      matTooltipPosition="above"
                      style="display: inline-block">
                  <button type="button" class="wst-turno-edit" [disabled]="!exitPermission('projectworkshift.UpdateShifts')" (click)="loadTurnoForEditing(turno.localId); $event.stopPropagation()">
                    <mat-icon>edit</mat-icon>
                  </button>
                </span>
                <span [matTooltip]="!exitPermission('projectworkshift.DeleteShifts') ? 'No cuentas con el permiso para eliminar turnos' : 'Eliminar turno'"
                      matTooltipPosition="above"
                      style="display: inline-block">
                  <button type="button" class="wst-turno-delete" [disabled]="!exitPermission('projectworkshift.DeleteShifts')" (click)="deleteTurno(turno, $event)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </span>
              </div>
              <div class="wst-turno-name-row">
                <span class="wst-turno-name">{{ turno.name }}</span>
                <span class="wst-turno-badge-active" *ngIf="isTurnoEffectivelyActive(turno)">Activo</span>
                <span class="wst-turno-badge-inactive" *ngIf="!isTurnoEffectivelyActive(turno)">Inactivo</span>
              </div>
              <div class="wst-turno-meta" *ngIf="turno.startHour && turno.endHour; else turnoDescansoMeta">
                {{ formatApiTimeRangeLocal(turno.startHour, turno.endHour) }}
              </div>
              <ng-template #turnoDescansoMeta>
                <div class="wst-turno-meta">Día libre · sin horario</div>
              </ng-template>
              <div class="wst-turno-stats" *ngIf="turno.startHour && turno.endHour">
                <span>Efectivo <strong>{{ turnoWorkedHoursLabel(turno) }}</strong></span>
                <span>Total <strong>{{ turnoTotalHoursLabel(turno) }}</strong></span>
                <span>Tiempo de descanso <strong>{{ turno.breakL }}:{{ turno.breakR }}</strong></span>
                <span>Trd
                  <span class="wst-turno-stats-value">
                    <strong>{{ turno.trdL }}:{{ turno.trdR }}</strong>
                    <em class="wst-turno-stats-format">(hh:mm)</em>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="wst-empty-hint" *ngIf="turnos.length === 0">
            Aún no hay turnos diarios creados para este proyecto. Crea uno arriba.
          </div>
        </ng-container>
      </section>

      <!-- ===== Pantalla: Patrones Semanales ===== -->
      <section class="wst-screen" *ngIf="!loading && activeTab === 'patrones'">
        <div class="wst-screen-title-row">
          <div class="wst-screen-title">Configuración de patrones</div>
          <div class="wst-create-item-group" *ngIf="!patternFormExpanded">
            <span class="wst-create-item-label">Crear nuevo patrón</span>
            <span [matTooltip]="!exitPermission('projectworkshift.CreateWeeklyPatterns') ? 'No cuentas con el permiso para crear patrones' : ''"
                  matTooltipPosition="above"
                  style="display: inline-block">
              <button type="button" class="wst-create-item-fab" [disabled]="!exitPermission('projectworkshift.CreateWeeklyPatterns')" (click)="openPatternForm()">
                <mat-icon>add</mat-icon>
              </button>
            </span>
          </div>
        </div>

        <div class="wst-form-card" *ngIf="patternFormExpanded">
          <div class="wst-form-header-row">
            <div class="wst-form-header">{{ draftPattern.id ? 'Editar patrón' : 'Crear nuevo patrón' }}</div>
            <div class="wst-active-toggle">
              <span>{{ draftPattern.isActive ? 'Activo' : 'Inactivo' }}</span>
              <mat-slide-toggle [(ngModel)]="draftPattern.isActive" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
            </div>
          </div>

          <div class="wst-editor-name-row">
            <div class="wst-editor-field wst-editor-field--grow">
              <label>Nombre del patrón</label>
              <div class="name-input-wrapper">
                <input type="text" [(ngModel)]="draftPattern.name" [ngModelOptions]="{standalone: true}"
                       placeholder="Ej: Semana Rotativa A"
                       (blur)="patternNameTouched = true"
                       [class.input-error]="patternNameInvalid"/>
              </div>
            </div>
          </div>
          <div class="name-required-alert" *ngIf="patternNameInvalid">
            <mat-icon style="color: red;">warning</mat-icon>
            <span>Debe colocarle nombre al patrón.</span>
          </div>

          <div class="wst-editor-time-row">
            <div class="wst-editor-field">
              <label>Duración del ciclo</label>
              <div class="wst-cycle-select">
                <select disabled>
                  <option>Semanal (7 días)</option>
                </select>
              </div>
            </div>
          </div>

          <div class="wst-col-header wst-col-header--sub">
            <span>Turnos para el patrón</span>
          </div>
          <div class="wst-chip-row" *ngIf="activeTurnos.length > 0">
            <div class="wst-chip"
                 *ngFor="let turno of activeTurnos; trackBy: trackByTurnoId"
                 [class.wst-chip--selected]="armedTurnoLocalId === turno.localId"
                 [style.background]="turno.color"
                 draggable="true"
                 (dragstart)="onTurnoDragStart($event, turno.localId)"
                 (dragend)="onTurnoDragEnd()"
                 (click)="armTurno(turno.localId)">
              <span class="wst-chip-name">{{ turno.name }}</span>
              <span class="wst-chip-range" *ngIf="turno.startHour && turno.endHour">{{ formatApiTimeRangeLocal(turno.startHour, turno.endHour) }}</span>
            </div>
          </div>
          <div class="wst-empty-hint" *ngIf="activeTurnos.length === 0">
            Aún no hay turnos diarios activos creados — ve a la pestaña "Turnos" para crear alguno y poder arrastrarlo aquí.
          </div>

          <div class="wst-col-hint">
            Diseño del ciclo — arrastra o toca un turno sobre un día. Todos los días deben tener un turno; para un día libre usa el turno "Descanso".
          </div>

          <div class="wst-cycle-grid">
            <div class="wst-cycle-cell"
                 *ngFor="let dayNumber of displayDayOrder"
                 [class.wst-cycle-cell--dragover]="dragOverDay === dayNumber"
                 (dragover)="onDayDragOver($event, dayNumber)"
                 (dragleave)="onDayDragLeave()"
                 (drop)="onDayDrop($event, dayNumber)"
                 (click)="onDayTap(dayNumber)">
              <div class="wst-cycle-cell-label">{{ diasSemanaCortas[dayNumber] }}</div>

              <ng-container *ngIf="draftPattern.days[dayNumber] as assignment; else emptyCell">
                <div class="wst-cycle-cell-assignment" [style.background]="assignment.color">
                  <mat-icon class="wst-cycle-cell-remove" (click)="removeDayAssignment(dayNumber, $event)">close</mat-icon>
                  <span class="wst-cycle-cell-name">{{ assignment.turnoName }}</span>
                  <ng-container *ngIf="!isRestAssignment(assignment); else restLabel">
                    <span class="wst-cycle-cell-range">{{ formatApiTimeRangeLocal(assignment.startHour, assignment.endHour) }}</span>
                    <span class="wst-cycle-cell-hours">{{ formatHoursEsLocal(dayWorkedHours(assignment)) }} h</span>
                  </ng-container>
                  <ng-template #restLabel>
                    <span class="wst-cycle-cell-range">Día libre</span>
                  </ng-template>
                </div>
              </ng-container>
              <ng-template #emptyCell>
                <div class="wst-cycle-cell-empty">Suelta</div>
              </ng-template>
            </div>
          </div>

          <div class="wst-summary-card">
            <div class="wst-summary-title">Resumen del ciclo completo</div>
            <div class="wst-summary-stats">
              <div class="wst-summary-stat">
                <span>Tiempo total</span>
                <strong>{{ formatHoursEsLocal(patternTotalRawHours(draftPattern)) }} h</strong>
              </div>
              <div class="wst-summary-stat">
                <span>Descansos</span>
                <strong>{{ patternBreakSummary(draftPattern) }}</strong>
              </div>
              <div class="wst-summary-stat" *ngIf="patternRestDaysCount(draftPattern) > 0">
                <span>Días libres</span>
                <strong>{{ patternRestDaysCount(draftPattern) }} {{ patternRestDaysCount(draftPattern) === 1 ? 'día' : 'días' }}</strong>
              </div>
              <div class="wst-summary-stat wst-summary-stat--highlight" [class.total-exceeded]="patternExceedsMax(draftPattern)">
                <span>Horas efectivas</span>
                <strong>
                  {{ formatHoursEsLocal(patternTotalHours(draftPattern)) }} h
                  <em *ngIf="maxWeeklyWorkHours">de {{ maxWeeklyWorkHours }} h</em>
                </strong>
              </div>
            </div>
          </div>

          <div class="name-required-alert" *ngIf="patternUnscheduledDays.length > 0">
            <mat-icon style="color: red;">warning</mat-icon>
            <span>Todos los días deben tener un turno. Sin programar: {{ patternUnscheduledDays.join(', ') }}.</span>
          </div>

          <div class="wst-form-actions">
            <button type="button" class="wst-cancel-btn" (click)="cancelPatternForm()">Cancelar</button>
            <button type="button" class="wst-save-turno-btn" [disabled]="saveDisabled" (click)="save()">
              {{ saving ? 'Guardando…' : (draftPattern.id ? 'Guardar patrón' : 'Confirmar y guardar patrón') }}
            </button>
          </div>
        </div>

        <ng-container *ngIf="!patternFormExpanded">
          <div class="wst-col-header wst-col-header--sub">
            <span>Patrones guardados</span>
            <div class="tTrd">
              <mat-icon>info</mat-icon>
              <span><b>Trd =</b> Tiempo trabajado a partir del cual se descuenta el tiempo de descanso</span>
            </div>
          </div>
          <div class="wst-saved-list" *ngIf="patterns.length > 0">
            <div class="wst-saved-card wst-saved-card--row"
                 *ngFor="let pattern of patterns; trackBy: trackByPatternId"
                 [class.wst-saved-card--active]="draftPattern.localId === pattern.localId">
              <div class="wst-saved-card-actions">
                <span class="wst-saved-card-badge" [ngClass]="pattern.isActive ? 'wst-badge-active' : 'wst-badge-inactive'">
                  {{ pattern.isActive ? 'Activo' : 'Inactivo' }}
                </span>
                <span [matTooltip]="!exitPermission('projectworkshift.UpdateWeeklyPatterns') ? 'No cuentas con el permiso para editar patrones' : 'Editar patrón'"
                      matTooltipPosition="above"
                      style="display: inline-block">
                  <button type="button" class="wst-saved-card-edit" [disabled]="!exitPermission('projectworkshift.UpdateWeeklyPatterns')" (click)="loadPatternIntoDraft(pattern)">
                    <mat-icon>edit</mat-icon>
                  </button>
                </span>
                <span [matTooltip]="!exitPermission('projectworkshift.DeleteWeeklyPatterns') ? 'No cuentas con el permiso para eliminar patrones' : 'Eliminar patrón'"
                      matTooltipPosition="above"
                      style="display: inline-block">
                  <button type="button" class="wst-saved-card-delete" [disabled]="!exitPermission('projectworkshift.DeleteWeeklyPatterns')" (click)="deletePattern(pattern, $event)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </span>
              </div>

              <div class="wst-saved-card-info">
                <span class="wst-saved-card-name">{{ pattern.name }}</span>
                <span class="wst-saved-card-sub">Ciclo de 7 días</span>
                <span class="wst-saved-card-sub">Total efectivo {{ formatHoursEsLocal(patternTotalHours(pattern)) }} h</span>
              </div>

              <div class="wst-saved-card-days">
                <div class="wst-saved-day" *ngFor="let dayNumber of displayDayOrder">
                  <span class="wst-saved-day-label">{{ diasSemanaCortas[dayNumber] }}</span>
                  <ng-container *ngIf="pattern.days[dayNumber] as assignment; else savedDayEmpty">
                    <div class="wst-saved-day-chip" [style.background]="assignment.color">
                      <span class="wst-saved-day-chip-name">{{ assignment.turnoName }}</span>
                      <span class="wst-saved-day-chip-range">
                        {{ isRestAssignment(assignment) ? '00:00 - 00:00' : formatApiTimeRangeLocal(assignment.startHour, assignment.endHour) }}
                      </span>
                    </div>
                  </ng-container>
                  <ng-template #savedDayEmpty>
                    <div class="wst-saved-day-chip wst-saved-day-chip--empty">Sin turno</div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="wst-empty-hint" *ngIf="patterns.length === 0">
            Aún no hay patrones semanales creados para este proyecto.
          </div>
        </ng-container>
      </section>

      <!-- ===== Pantalla: Patrones Catorcenales (rotaciones de 14 días) ===== -->
      <section class="wst-screen" *ngIf="!loading && activeTab === 'catorcenales'">
        <div class="wst-screen-title-row">
          <div class="wst-screen-title">Configuración de patrones</div>
          <div class="wst-create-item-group" *ngIf="!rotationFormExpanded">
            <span class="wst-create-item-label">Crear nuevo patrón</span>
            <span [matTooltip]="!exitPermission('projectworkshift.CreateWeeklyPatterns') ? 'No cuentas con el permiso para crear patrones' : ''"
                  matTooltipPosition="above"
                  style="display: inline-block">
              <button type="button" class="wst-create-item-fab" [disabled]="!exitPermission('projectworkshift.CreateWeeklyPatterns')" (click)="openRotationForm()">
                <mat-icon>add</mat-icon>
              </button>
            </span>
          </div>
        </div>

        <div class="wst-form-card" *ngIf="rotationFormExpanded">
          <div class="wst-form-header-row">
            <div class="wst-form-header">{{ draftRotation.id ? 'Editar patrón' : 'Crear nuevo patrón' }}</div>
            <div class="wst-form-toggles">
              <div class="wst-active-toggle"
                   matTooltip="Encendido: el patrón se repite por siempre, sin fecha fin. Apagado: se indica hasta cuándo es vigente."
                   matTooltipPosition="above">
                <span>Repetir indefinidamente</span>
                <mat-slide-toggle [(ngModel)]="draftRotation.repeatIndefinitely" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
              </div>
              <div class="wst-active-toggle">
                <span>{{ draftRotation.isActive ? 'Activo' : 'Inactivo' }}</span>
                <mat-slide-toggle [(ngModel)]="draftRotation.isActive" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
              </div>
            </div>
          </div>

          <div class="wst-editor-name-row">
            <div class="wst-editor-field wst-editor-field--grow">
              <label>Nombre del patrón</label>
              <div class="name-input-wrapper">
                <input type="text" [(ngModel)]="draftRotation.name" [ngModelOptions]="{standalone: true}"
                       placeholder="Ej: Semana Rotativa A"
                       (blur)="rotationNameTouched = true"
                       [class.input-error]="rotationNameInvalid"/>
              </div>
            </div>
          </div>
          <div class="name-required-alert" *ngIf="rotationNameInvalid">
            <mat-icon style="color: red;">warning</mat-icon>
            <span>Debe colocarle nombre al patrón.</span>
          </div>

          <div class="wst-editor-time-row">
            <div class="wst-editor-field">
              <label>Duración del ciclo</label>
              <div class="wst-cycle-select">
                <select disabled>
                  <option>Catorcenal ({{ biweeklyCycleDays }} días)</option>
                </select>
              </div>
            </div>
          </div>

          <div class="wst-editor-time-row" *ngIf="!draftRotation.repeatIndefinitely">
            <div class="wst-editor-field">
              <label>Vigente hasta</label>
              <div class="time-input-wrapper">
                <input type="date" class="time-input" [(ngModel)]="draftRotation.endDate" [ngModelOptions]="{standalone: true}"
                       [attr.min]="todayDateKey"
                       [class.input-error]="rotationEndDateInvalid"/>
              </div>
            </div>
          </div>
          <div class="name-required-alert" *ngIf="rotationEndDateInvalid">
            <mat-icon style="color: red;">warning</mat-icon>
            <span>Indica hasta qué fecha es vigente el patrón (hoy o posterior), o enciende "Repetir indefinidamente".</span>
          </div>

          <div class="wst-rotation-versions-hint" *ngIf="draftRotation.id && draftRotation.assignedContracts > 0">
            <mat-icon>info</mat-icon>
            <span>
              {{ draftRotation.assignedContracts }} {{ draftRotation.assignedContracts === 1 ? 'contrato tiene' : 'contratos tienen' }}
              asignado este patrón. Si cambias sus días se crea una versión nueva: quienes ya lo tienen conservan la anterior
              hasta que se les vuelva a asignar.
            </span>
          </div>

          <div class="wst-col-header wst-col-header--sub">
            <span>Turnos para el patrón</span>
          </div>
          <div class="wst-chip-row" *ngIf="activeTurnos.length > 0">
            <div class="wst-chip"
                 *ngFor="let turno of activeTurnos; trackBy: trackByTurnoId"
                 [class.wst-chip--selected]="armedTurnoLocalId === turno.localId"
                 [style.background]="turno.color"
                 draggable="true"
                 (dragstart)="onTurnoDragStart($event, turno.localId)"
                 (dragend)="onTurnoDragEnd()"
                 (click)="armTurno(turno.localId)">
              <span class="wst-chip-name">{{ turno.name }}</span>
              <span class="wst-chip-range" *ngIf="turno.startHour && turno.endHour">{{ formatApiTimeRangeLocal(turno.startHour, turno.endHour) }}</span>
            </div>
          </div>
          <div class="wst-empty-hint" *ngIf="activeTurnos.length === 0">
            Aún no hay turnos diarios activos creados — ve a la pestaña "Turnos" para crear alguno y poder arrastrarlo aquí.
          </div>

          <div class="wst-col-hint">
            Diseño del ciclo — arrastra o toca un turno sobre un día. Todos los días deben tener un turno; para un día libre usa el turno "Descanso".
          </div>

          <div class="wst-cycle-grid wst-cycle-grid--rotation">
            <div class="wst-cycle-cell"
                 *ngFor="let dayIndex of rotationWeeks[0].concat(rotationWeeks[1])"
                 [class.wst-cycle-cell--dragover]="dragOverRotationDay === dayIndex"
                 (dragover)="onRotationDayDragOver($event, dayIndex)"
                 (dragleave)="onRotationDayDragLeave()"
                 (drop)="onRotationDayDrop($event, dayIndex)"
                 (click)="onRotationDayTap(dayIndex)">
              <div class="wst-cycle-cell-label">{{ rotationDayLabel(dayIndex) }}</div>

              <ng-container *ngIf="draftRotation.days[dayIndex] as assignment; else emptyRotationCell">
                <div class="wst-cycle-cell-assignment" [style.background]="assignment.color">
                  <mat-icon class="wst-cycle-cell-remove" (click)="removeRotationDay(dayIndex, $event)">close</mat-icon>
                  <span class="wst-cycle-cell-name">{{ assignment.turnoName }}</span>
                  <ng-container *ngIf="!isRestAssignment(assignment); else rotationRestLabel">
                    <span class="wst-cycle-cell-range">{{ formatApiTimeRangeLocal(assignment.startHour, assignment.endHour) }}</span>
                    <span class="wst-cycle-cell-hours">{{ formatHoursEsLocal(dayWorkedHours(assignment)) }} h</span>
                  </ng-container>
                  <ng-template #rotationRestLabel>
                    <span class="wst-cycle-cell-range">Día libre</span>
                  </ng-template>
                </div>
              </ng-container>
              <ng-template #emptyRotationCell>
                <div class="wst-cycle-cell-empty">Suelta</div>
              </ng-template>
            </div>
          </div>

          <div class="wst-summary-card">
            <div class="wst-summary-title">Resumen del ciclo completo</div>
            <div class="wst-summary-stats">
              <div class="wst-summary-stat">
                <span>Tiempo total</span>
                <strong>{{ formatHoursEsLocal(patternTotalRawHours(draftRotation)) }} h</strong>
              </div>
              <div class="wst-summary-stat">
                <span>Descansos</span>
                <strong>{{ patternBreakSummary(draftRotation) }}</strong>
              </div>
              <div class="wst-summary-stat" *ngIf="patternRestDaysCount(draftRotation) > 0">
                <span>Días libres</span>
                <strong>{{ patternRestDaysCount(draftRotation) }} {{ patternRestDaysCount(draftRotation) === 1 ? 'día' : 'días' }}</strong>
              </div>
              <div class="wst-summary-stat wst-summary-stat--highlight" [class.total-exceeded]="rotationExceedsMax(draftRotation)">
                <span>Horas efectivas</span>
                <strong>
                  {{ formatHoursEsLocal(patternTotalHours(draftRotation)) }} h
                  <em *ngIf="maxRotationWorkHours">de {{ maxRotationWorkHours }} h</em>
                </strong>
              </div>
            </div>
          </div>

          <div class="name-required-alert" *ngIf="rotationExceedsMax(draftRotation)">
            <mat-icon style="color: red;">warning</mat-icon>
            <span>El ciclo supera el doble de las horas semanales permitidas ({{ maxRotationWorkHours }} h).</span>
          </div>
          <div class="name-required-alert" *ngIf="rotationHasNoWorkDays && rotationHasAnyAssignment">
            <mat-icon style="color: red;">warning</mat-icon>
            <span>El patrón debe tener al menos un día de trabajo.</span>
          </div>

          <div class="name-required-alert" *ngIf="rotationUnscheduledDays.length > 0">
            <mat-icon style="color: red;">warning</mat-icon>
            <span>Todos los días deben tener un turno. Sin programar: {{ rotationUnscheduledDays.join(', ') }}.</span>
          </div>

          <div class="wst-form-actions">
            <button type="button" class="wst-cancel-btn" (click)="cancelRotationForm()">Cancelar</button>
            <button type="button" class="wst-save-turno-btn" [disabled]="rotationSaveDisabled" (click)="saveRotation()">
              {{ savingRotation ? 'Guardando…' : (draftRotation.id ? 'Guardar patrón' : 'Confirmar y guardar patrón') }}
            </button>
          </div>
        </div>

        <ng-container *ngIf="!rotationFormExpanded">
          <div class="wst-col-header wst-col-header--sub">
            <span>Patrones guardados</span>
            <div class="tTrd">
              <mat-icon>info</mat-icon>
              <span><b>Trd =</b> Tiempo trabajado a partir del cual se descuenta el tiempo de descanso</span>
            </div>
          </div>
          <div class="wst-saved-list" *ngIf="rotations.length > 0">
            <div class="wst-saved-card wst-saved-card--row"
                 *ngFor="let rotation of rotations; trackBy: trackByRotationId"
                 [class.wst-saved-card--active]="draftRotation.localId === rotation.localId">
              <div class="wst-saved-card-actions">
                <span class="wst-saved-card-badge" [ngClass]="rotation.isActive ? 'wst-badge-active' : 'wst-badge-inactive'">
                  {{ rotation.isActive ? 'Activo' : 'Inactivo' }}
                </span>
                <span [matTooltip]="!exitPermission('projectworkshift.UpdateWeeklyPatterns') ? 'No cuentas con el permiso para editar patrones' : 'Editar patrón'"
                      matTooltipPosition="above"
                      style="display: inline-block">
                  <button type="button" class="wst-saved-card-edit" [disabled]="!exitPermission('projectworkshift.UpdateWeeklyPatterns')" (click)="loadRotationIntoDraft(rotation)">
                    <mat-icon>edit</mat-icon>
                  </button>
                </span>
              </div>

              <div class="wst-saved-card-info">
                <span class="wst-saved-card-name">{{ rotation.name }}</span>
                <span class="wst-saved-card-sub">Ciclo de {{ biweeklyCycleDays }} días{{ rotation.repeatIndefinitely ? ' · se repite indefinidamente' : ' · vigente hasta ' + rotation.endDate }}</span>
                <span class="wst-saved-card-sub">Total efectivo {{ formatHoursEsLocal(patternTotalHours(rotation)) }} h</span>
                <span class="wst-saved-card-sub" *ngIf="rotation.assignedContracts > 0">
                  {{ rotation.assignedContracts }} {{ rotation.assignedContracts === 1 ? 'contrato asignado' : 'contratos asignados' }}
                </span>
              </div>

              <div class="wst-saved-card-days">
                <div class="wst-saved-day" *ngFor="let dayIndex of rotationWeeks[0].concat(rotationWeeks[1])">
                  <span class="wst-saved-day-label">{{ rotationDayLabel(dayIndex) }}</span>
                  <ng-container *ngIf="rotation.days[dayIndex] as assignment; else rotationSavedDayEmpty">
                    <div class="wst-saved-day-chip" [style.background]="assignment.color">
                      <span class="wst-saved-day-chip-name">{{ assignment.turnoName }}</span>
                      <span class="wst-saved-day-chip-range">
                        {{ isRestAssignment(assignment) ? '00:00 - 00:00' : formatApiTimeRangeLocal(assignment.startHour, assignment.endHour) }}
                      </span>
                    </div>
                  </ng-container>
                  <ng-template #rotationSavedDayEmpty>
                    <div class="wst-saved-day-chip wst-saved-day-chip--empty">Sin turno</div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="wst-empty-hint" *ngIf="rotations.length === 0 && !rotationsLoadError">
            Aún no hay patrones catorcenales creados para este proyecto.
          </div>
          <div class="name-required-alert" *ngIf="rotationsLoadError">
            <mat-icon style="color: red;">warning</mat-icon>
            <span>No se pudieron cargar los patrones catorcenales. Intenta de nuevo más tarde.</span>
          </div>
        </ng-container>
      </section>
    </div>
  </div>
</div>
